import { useState, useEffect } from "react";
import { validateItineraryChronology } from "../helpers/GetAQuoteHelpers";
import { v4 as uuidv4 } from "uuid";

export default function useLocations(tripType) {
  const [stopOrderIsValid, setstopOrderIsValid] = useState(null);
  const [locations, setLocations] = useState(() => {
    const departure = {
      id: uuidv4(),
      placeId: null,
      type: "departure",
      address: "",
    };

    const stop = {
      id: uuidv4(),
      placeId: null,
      type: "stop",
      address: "",
    };

    const destination = {
      id: uuidv4(),
      placeId: null,
      type: "destination",
      address: "",
    };

    return tripType === "round_trip"
      ? [departure, stop, destination]
      : [departure, destination];
  });

  const updateLocation = (index, updates) => {
    setLocations((prev) => {
      const updated = prev.map((loc, i) =>
        i === index ? { ...loc, ...updates } : loc,
      );

      if (tripType === "round_trip" && updated.length >= 3 && index === 0) {
        const departure = updated[0];

        const { date, time, id, ...baseDeparture } = departure;

        updated[2] = {
          ...updated[2],
          ...baseDeparture,
          id: updated[2].id ?? uuidv4(),
          type: "destination",
          locationType: "destination",
        };
      }

      return updated;
    });
  };

  const hasAllLocations = locations.every((location, index) => {
    const isLast = index === locations.length - 1;

    if (isLast) {
      return location.address;
    }

    return location.address && location.date && location.time;
  });

  const hasValidLocation = locations.some(
    (location) => location.address && location.date && location.time,
  );

  useEffect(() => {
    const { isValid } = validateItineraryChronology(locations);
    setstopOrderIsValid(isValid);
  }, [locations]);

  return {
    locations,
    setLocations,
    updateLocation,
    stopOrderIsValid,
    hasAllLocations,
    hasValidLocation,
  };
}
